import { render, staticRenderFns } from "./FUmkmTable.vue?vue&type=template&id=12c245f2&scoped=true"
import script from "./FUmkmTable.vue?vue&type=script&lang=js"
export * from "./FUmkmTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c245f2",
  null
  
)

export default component.exports